import { FC } from 'react'
import {ProductThumb} from '../../../../components/common/ProductThumb'
import { IRemovedPOItem } from '../../core/_models'
import { useIntl } from 'react-intl'

interface IProps {
  items: IRemovedPOItem[]
}

const RemovedPurchaseTable: FC<IProps> = ({ items }) => {
  const { formatMessage } = useIntl()

  if (!items || items.length === 0) return null

  return (
    <div className='table-responsive' style={{ height: 'auto' }}>
      <table className='table align-middle gs-0 gy-5 mb-0'>
        <thead>
          <tr>
            <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>{formatMessage({ id: 'image' })}</th>
            <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>{formatMessage({ id: 'barcode' })}</th>
            <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>{formatMessage({ id: 'model_num' })}</th>
            <th className='fw-bold p-0 text-uppercase'>{formatMessage({ id: 'prod_name' })}</th>
            <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>{formatMessage({ id: 'qty' })}</th>
            <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>{formatMessage({ id: 'cost_price' })}</th>
            <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>{formatMessage({ id: 'sale_price' })}</th>
            <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>{formatMessage({ id: 'total_price' })}</th>
            <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>{formatMessage({ id: 'reason', defaultMessage: 'Reason' })}</th>
            <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>{formatMessage({ id: 'date_added', defaultMessage: 'Date Added' })}</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={`${item.product_id}-${item.date_added}`} className='border-bottom border-dashed border-gray-400'>
              <th>
                <ProductThumb className='table-img' width='100' height='100' src={item.image} />
              </th>
              <td>{item.barcode}</td>
              <td>{item.model}</td>
              <td className='w-250px'>{item.name}</td>
              <td>{item.quantity}</td>
              <td>{item.cost}</td>
              <td>{item.price}</td>
              <td>{typeof item.total_cost === 'number' ? item.total_cost.toFixed(2) : item.total_cost}</td>
              <td>{item.reason_name}</td>
              <td>{item.date_added}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default RemovedPurchaseTable
